// extracted by mini-css-extract-plugin
module.exports = {"sections-page-container":"sections_sections-page-container__2nHpU"};